import { RANGE_FILTER } from '@nykaa/price-filter-shared/constants';

export const filterTypes = {
  SINGLE_SELECT: 'single-select',
  MULTI_SELECT: 'multi-select',
  RANGE: RANGE_FILTER,
  CATEGORY: 'category-filter',
  COLOR: 'color-filter',
};

export const FILTER_APPLIED = 'filter_applied';
